<template>

    <body class="dx-viewport">
        <DxDataGrid ref="dataGridPeUserRef" :allowColumnReordering="true" :data-source="dsTargetPeUser"
            :allowColumnResizing="true" key-expr="ID" :columnAutoWidth="false" :columnMinWidth="50"
            :columnResizingMode="'nextColumn'" :show-borders="true" :syncLookupFilterValues="false"
            :filter-sync-enabled="true" :show-row-lines="true" :show-column-lines="true" @row-inserting="onRowInserting"
            @row-updated="onRowUpdated" @row-removed="onRowRemoved">
            <DxSelection mode="single" />
            <DxFilterRow :visible="true" />
            <DxPaging :page-size="5" :page-index="1" />
            <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
            <DxSorting mode="multiple" />
            <DxStateStoring :enabled="true" :filterValue="false" storage-key="TargetPeUser" />
            <DxColumnChooser :enabled="true" mode="select" />
            <DxToolbar>
                <DxItem>
                    <template #default>
                        <DxButton icon="add" type="success" @click="onAddClick" />
                    </template>
                </DxItem>
                <DxItem>
                    <template #default>
                        <DxButton icon="refresh" @click="onRefreshClick" />
                    </template>
                </DxItem>
                <DxItem name="columnChooserButton" />
            </DxToolbar>
            <DxEditing :allowUpdating="true" :allowDeleting="true" mode="popup">
                <DxPopup :closeOnOutsideClick="false" :showCloseButton="false" :width="500" :height="200">
                    <DxToolbarItem :template="customTitleTemplate" />
                    <DxToolbarItem toolbar="bottom" widget="dxButton" location="after"
                        :options="successButtonOptions" />
                    <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="dangerButtonOptions" />
                </DxPopup>
                <DxFormGrid>
                    <DxItem :col-span="2" :col-count="2" item-type="group">
                        <DxItem data-field="Target" :col-span="1" editorType="dxNumberBox"
                            :editorOptions="{ format: '#,##0.00', precision: 2 }" />
                        <DxItem dataField="TargetID" :colSpan="1" :isRequired="false" :visible="false" />
                        <DxItem dataField="ValutaID" :visible="true" />
                    </DxItem>
                </DxFormGrid>
            </DxEditing>
            <DxColumn dataField="ID" :visible="false" />
            <DxColumn data-field="Utilizator" />
            <DxColumn data-field="Target" format="#,##0.00" />
            <DxColumn data-field="TargetID" :visible="false" />
            <DxColumn data-field="TargetRealizat" format="#,##0.00" />
            <DxColumn data-field="ValutaID" caption="Valuta">
                <DxLookup :data-source="valute" display-expr="Simbol" value-expr="Id" />
            </DxColumn>
            <DxSummary>
                <DxTotalItem column="Target" summary-type="sum" display-format="Total: {0}"
                    :value-format="{ type: 'fixedPoint', precision: 2 }" />
            </DxSummary>
        </DxDataGrid>
        <DxPopupAdd :visible.sync="isModalVisible" :closeOnOutsideClick="false" :showCloseButton="false"
            :showTitle="true" :width="550" :height="320">
            <template #title>
                <div
                    style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold;  padding: 10px; padding-left: 20px; ">
                    Adăugare</div>
            </template>
            <div>
                <DxForm :formData="formData">
                    <DxItem :col-span="1" :col-count="1" item-type="group">

                        <DxItem dataField="TargetID" :visible="false" />

                        <DxItem dataField="Utilizator" :isRequired="true">
                            <DxSelectBox :dataSource="dsUsers" display-expr="Username" value-expr="Username"
                                :search-enabled="true" v-model="formData.Utilizator" />
                        </DxItem>

                        <DxItem item-type="group" :col-count="2" :col-span="1">
                            <DxItem dataField="Target" :isRequired="true" editorType="dxNumberBox"
                                :editorOptions="{ format: '#,##0.00', precision: 2 }"
                                :validation-rules="[{ type: 'numeric', message: 'Câmpul trebuie să conțină doar numere.' }]" />

                            <DxItem dataField="ValutaID" :isRequired="true" editorType="dxSelectBox" :editorOptions="{
                                dataSource: valute,
                                displayExpr: 'Simbol',
                                valueExpr: 'Id'
                            }" :label="{ text: 'Valuta' }" />
                        </DxItem>

                    </DxItem>
                </DxForm>

                <div style="display: flex; justify-content: flex-end; gap: 8px; margin-top: 30px;">
                    <DxButton text="Salvează" type="success" width="100" @click="onSave" />
                    <DxButton text="Închide" type="danger" width="100" @click="onCancel" />
                </div>
            </div>
        </DxPopupAdd>
    </body>
</template>

<script lang="ts">
import { defineComponent, readonly, ref } from 'vue';
import { DxButton } from 'devextreme-vue/button';
import DxPopupAdd, { DxToolbarItem } from 'devextreme-vue/popup';
import { DxItem, DxForm, DxLabel } from 'devextreme-vue/form';
import { DxSelectBox } from 'devextreme-vue/select-box'
import { DxTextBox } from 'devextreme-vue/text-box'
import {
    DxColumn,
    DxDataGrid,
    DxFilterRow,
    DxLoadPanel,
    DxPaging,
    DxSelection,
    DxSorting,
    DxStateStoring,
    DxToolbar,
    DxEditing,
    DxPopup,
    DxItem as DxItemForm,
    DxForm as DxFormGrid,
    DxValidationRule,
    DxRequiredRule,
    DxScrolling,
    DxSearchPanel,
    DxLookup,
    DxSummary,
    DxTotalItem,
    DxColumnChooser,
} from 'devextreme-vue/data-grid';
import 'devextreme/dist/css/dx.light.css';
import 'devextreme/dist/css/dx.common.css';
import AppSetting from '@/settings/appSettings';
import UserCompanyServices from '@/services/Administrare/UserCompanyService';
import CrmNomenclatoare from '@/services/Comercial/CrmNomenclatoare';
import CrmTargetPeUser from '@/services/Comercial/CrmTargetPeUser';
import notify from 'devextreme/ui/notify';
import { locale, loadMessages } from 'devextreme/localization';
import { watch, onMounted } from 'vue';
import DataSource from 'devextreme/data/data_source';
import http from "@/settings/apiSettings";
import UserService from '@/services/Administrare/UserService';
import AUTH_Users from '@/services/AUTH/AUTH_Users';


export default defineComponent({
    components: {
        DxToolbar,
        DxDataGrid,
        DxColumn,
        DxSorting,
        DxSelection,
        DxFilterRow,
        DxStateStoring,
        DxLoadPanel,
        DxPaging,
        DxButton,
        DxItem,
        DxPopup,
        DxForm,
        DxLabel,
        DxEditing,
        DxPopupAdd,
        DxToolbarItem,
        DxItemForm,
        DxFormGrid,
        DxValidationRule,
        DxRequiredRule,
        DxSelectBox,
        DxTextBox,
        DxScrolling,
        DxSearchPanel,
        DxLookup,
        DxSummary,
        DxTotalItem,
        DxColumnChooser,
    },
    props: {
        TargetID: String
    },
    data() {
        return {
            target: [
                { ID: 1, TargetID: 1, Utilizator: 'Gina_Calugarita', Target: '800000' },
                { ID: 2, TargetID: 2, Utilizator: 'Damian_Denes', Target: '109250' },
                // Add more contacts
            ],
            agenti: [],
            dsTargetPeUser: {} as any,
            dsAgenti: {} as any,
            dsUsers: [] as any[],
            isModalVisible: false,
            formData: {
                TargetID: null,
                Utilizator: null,
                Target: 0,
                ValutaID: null,
            },
            valute: [] as any[],
            deleteConfirmationMessage: "Sigur doriți să ștergeți această înregistrare?",

            successButtonOptions: {
                type: 'success',
                stylingMode: 'contained',
                text: 'Salvează',
                onClick: () => {
                    this.onSaveEdit();
                },
            },
            dangerButtonOptions: {
                type: 'danger',
                stylingMode: 'contained',
                text: 'Închide',
                onClick: () => {
                    this.onCancelEdit();
                },
            },
            customTitleTemplate() {
                return `
          <div style="background-color: #ff2c21; font-size: 16px; float: right; height:47px; width:515px; color: white; 
          font-weight: bold;  padding: 15px; padding-right: 460px;  position: relative;  left: 30px;">
            Editare
          </div>
        `;
            },
        };
    },
    computed: {

    },
    watch: {
        TargetID: {
            immediate: true,
            handler(newVal) {
                this.createODataContext(newVal);
            },
        },
    },
    methods: {
        async getValute() {
            try {
                const response = await http.clientComercialOdata.get('/ERP_Valute?$select=Id,Simbol');
                this.valute = response.data.value;
            } catch (e) {
                console.error("Error fetching valute:", e);
            }
        },
        createODataContext(TargetID?: string) {
            this.dsTargetPeUser = new DataSource({
                load: async (loadOptions: any) => {
                    if (!TargetID) return [];
                    try {
                        const response = await http.clientComercialOdata.get('/CRM_TargetPeUser', {
                            params: {
                                '$filter': `TargetID eq ${TargetID.toString().replace(/'/g, "")}`,
                                '$expand': 'Valuta($select=Id,Simbol)'
                            }
                        });
                        return response.data.value;
                    } catch (e) {
                        console.error('Error fetching TargetPeUser:', e);
                        return [];
                    }
                },
                update: (key, values) => {
                    return http.clientComercialOdata.patch(`/CRM_TargetPeUser(${key})`, values);
                },
                remove: (key) => {
                    return http.clientComercialOdata.delete(`/CRM_TargetPeUser(${key})`);
                },
                key: 'ID'
            });

            this.dsAgenti = new DataSource({
                load: async (loadOptions: any) => {
                    try {
                        const response = await http.clientComercialOdata.get('/COM_Agenti', {
                            params: {
                                '$select': 'Id,Nume'
                            }
                        });
                        return response.data.value;
                    } catch (e) {
                        console.error('Error fetching agents:', e);
                        return [];
                    }
                },
                key: 'Id'
            });

        },
        getUsers() {
            AUTH_Users.get()
                .then((response: any) => {
                    const allUsers = response.data || [];
                    // Get usernames already in the grid
                    const currentItems = this.dsTargetPeUser.items() || [];
                    const existingUsernames = currentItems.map((u: any) => u.Utilizator);

                    this.dsUsers = allUsers.filter((u: any) => !existingUsernames.includes(u.Username));
                })
                .catch((e: Error) => {
                    console.error('Error fetching unallocated users:', e);
                });
        },
        async getAgents() {
            try {
                const result = await CrmTargetPeUser.getAgenti();
                this.agenti = result.data
                console.log(this.agenti)
            } catch (err) {
                console.error(err);
            }
        },
        onAddClick() {
            this.getUsers();
            this.isModalVisible = true;
        },
        onSave() {
            this.formData.TargetID = this.TargetID;
            if (!this.formData.Utilizator || this.formData.Utilizator.trim() === '') {
                notify('Completați câmpul obligatoriu "Utilizator"!', 'error', 1000);
                return;
            }
            if (!this.formData.Target) {
                notify('Completați câmpul obligatoriu "Target"!', 'error', 1000);
                return;
            }
            const savePromise = this.$refs.dataGridPeUserRef?.instance?.saveEditData();
            console.log(this.formData);
            const body = this.formData;
            CrmTargetPeUser.save(body).then((response) => {
                this.isModalVisible = false;
                this.dsTargetPeUser.reload();
                notify('Datele au fost salvate cu succes!', 'success', 1000);
                this.formData = {

                    Utilizator: '',
                    Target: '',
                    ValutaID: null,
                };
            }).catch((error) => {
                console.error(error);
                notify('Datele există deja!', 'error', 1000);
            });
        },
        onCancel() {
            this.isModalVisible = false;
        },
        onValuteRowClick(e) {
            this.isValutaGridBoxOpened = false;
            if (e.selectedRowKeys.length > 0) {
                this.formData.ValutaID = e.selectedRowKeys[0];
            } else {
                this.formData.ValutaID = null;
            }
        },
        setDeleteConfirmationMessage() {
            const dataGrid = this.$refs.dataGridPeUserRef?.instance;
            dataGrid.option('editing', {
                allowUpdating: true,
                allowDeleting: true,
                mode: 'popup',
                texts: {
                    confirmDeleteMessage: this.deleteConfirmationMessage,
                    confirmDeleteTitle: "Confirmare Ștergere",
                }
            });
        },
        onClick() {
            this.isModalVisible = true;
            //this.getAgents()
        },
        onColumnChooserClick() {
            const dataGrid = (this.$refs.dataGridPeUserRef as any).instance;
            dataGrid.showColumnChooser();
        },
        onRefreshClick() {
            this.createODataContext(this.TargetID);
            notify('Datele au fost actualizate cu succes!', 'success', 1000)
        },
        onSaveEdit() {
            // const savePromise = this.$refs.dataGridPeUserRef?.instance?.saveEditData();
            // savePromise.then((result) => {
            //   this.dataGridPeUserRef?.instance?.saveEditData();
            //   notify('Datele au fost actualizate cu succes!','success', 1000)
            // }).catch((error) => {
            //   console.error(error);
            // });
            this.dataGridPeUserRef?.instance?.saveEditData()
        },
        onCancelEdit() {
            this.dataGridPeUserRef?.instance?.cancelEditData();
        },
        onRowUpdated() {
            notify('Datele au fost actualizate cu succes!', 'success', 1000);
        },
        onRowRemoved() {
            notify('Datele au fost șterse cu succes!', 'success', 1000);
        },
        onRowInserting() {
            notify('Datele au fost adăugate cu succes!', 'success', 1000)
        },
    },
    mounted() {
        this.createODataContext();
        this.getUsers();
        this.getValute();
        this.dataGridPeUserRef = this.$refs.dataGridPeUserRef as DxDataGrid;
        this.setDeleteConfirmationMessage();
        loadMessages({
            "ro": {
                "Yes": "Da",
                "No": "Nu",
            }
        });
        locale('ro');
    },
});
</script>
<style scoped>
.border {
    border-radius: 8px;
}
</style>